import { safeFormatMessage } from '@10xlabs/utils'
import { kebabCase } from 'lodash'
import { IntlShape, defineMessages } from 'react-intl'

import { INewPlaceForm, IPlacesFiltersForm } from 'features/Places/types'
import {
  GTBusinessSiteSuggestion,
  GTCitySuggestion,
  GTCompanySuggestion,
  GTPlaceAmenity,
  GTPlaceSuggestion,
  GTTPlaceVertical
} from 'gql/types.generated'
import { getQueryString } from 'utils/route'
import { STATES } from 'utils/states'
import { BusinessClientSuggestion } from 'gql/generated/graphql'

export const getParamValue = (name: string, city: INewPlaceForm['city']): string => {
  return kebabCase(`${name} ${city.name}`)
}

export const placeAmenitiesMessages = defineMessages({
  [GTPlaceAmenity.KolorsMobile]: {
    id: 'places.new.form.amenities.kolorsMobile',
    defaultMessage: 'Kolors Mobile'
  },
  [GTPlaceAmenity.KolorsTicket]: {
    id: 'places.new.form.amenities.kolorsTickets',
    defaultMessage: 'Kolors Tickets'
  }
})

export const mapAmenitiesToForm = (
  amenities: GTPlaceAmenity[],
  intl: IntlShape
): { id: GTPlaceAmenity; label: string }[] => {
  return amenities.map((key) => {
    return {
      id: key,
      label: safeFormatMessage({ intl, messages: placeAmenitiesMessages, key })
    }
  })
}

export const isValidLatitude = (latitude: string): boolean => {
  return parseFloat(latitude) >= -90 && parseFloat(latitude) <= 90
}

export const isValidLongitude = (longitude: string): boolean => {
  return parseFloat(longitude) >= -180 && parseFloat(longitude) <= 180
}

export const isCompanyRequired = (vertical: GTTPlaceVertical): boolean => {
  return vertical === GTTPlaceVertical.Team || vertical === GTTPlaceVertical.Rental
}

export const mapFiltersToSearchQueryString = (filters: IPlacesFiltersForm, pageNb = 1): string => {
  return getQueryString({
    page: pageNb,
    code: filters.code,
    stateCode: filters.state?.code,
    placeId: filters.place?.id,
    cityId: filters.city?.id,
    companyId: filters.company?.id,
    businessClientId: filters.businessClient?.id,
    businessSiteId: filters.businessSite?.id
  })
}

export const mapSearchToFiltersForm = (
  queries: Record<string, string | undefined>,
  {
    city,
    place,
    company,
    businessClient,
    businessSite
  }: {
    city: GTCitySuggestion | null
    place: GTPlaceSuggestion | null
    company: GTCompanySuggestion | null
    businessClient: BusinessClientSuggestion | null
    businessSite: GTBusinessSiteSuggestion | null
  }
): IPlacesFiltersForm => {
  const stateCode = queries.stateCode || ''
  const companyId = queries.companyId || ''

  return {
    code: queries.code || '',
    company: company || {
      id: companyId || '',
      name: ''
    },
    place: place || {
      id: queries.placeId || '',
      name: ''
    },
    city: city || {
      id: '',
      name: ''
    },
    businessClient: businessClient || {
      id: '',
      name: ''
    },
    businessSite: businessSite || {
      id: '',
      name: ''
    },
    state: STATES.find((state) => state.code === stateCode) || {
      code: '',
      name: ''
    }
  }
}
